module.exports = __webpack_public_path__ + "img/youtube1.81648bdf.png";